import {Component, Input, OnInit} from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-copilot-wizard-focus-areas',
  imports: [
    NgIf,
    NgForOf
  ],
  templateUrl: './copilot-wizard-focus-areas.component.html',
  styleUrl: './copilot-wizard-focus-areas.component.scss'
})
export class CopilotWizardFocusAreasComponent implements OnInit{
  @Input() title: string = '';
  @Input() subQuestions: string[] = [];
  @Input() titleSelected!: FormControl<boolean>;
  @Input() subSelected!: FormControl<Record<string, boolean>>;

  public topChecked = false;
  public subChecked: Record<string, boolean> = {};

  ngOnInit(): void {
    this.topChecked = this.titleSelected.value;
    this.subChecked = this.subSelected.value;
  }

  public toggleTop() {
    this.topChecked = !this.topChecked;
    this.titleSelected.setValue(this.topChecked);

    if (!this.topChecked) {
      this.subChecked = {};
      this.subSelected.setValue({});
    }
  }

  public toggleSub(text: string) {
    this.subChecked[text] = !this.subChecked[text];
    this.subSelected.setValue({ ...this.subChecked });
  }
}
